export default {
  "Plombier/Chauffagiste": {
    "requiresAuth": false
  },
  "Maçon": {
    "requiresAuth": true
  },
  "Couvreur": {
    "requiresAuth": true
  },
  "Menuisier": {
    "requiresAuth": true
  },
  "Électricien": {
    "requiresAuth": true
  },
  "Peintre": {
    "requiresAuth": true
  },
  "Carreleur": {
    "requiresAuth": true
  },
  "Plâtrier": {
    "requiresAuth": true
  },
  "Étancheur": {
    "requiresAuth": true
  },
  "Charpentier": {
    "requiresAuth": true
  },
  "Dessinateur": {
    "requiresAuth": true
  },
  "Serrurier": {
    "requiresAuth": true
  },
  "Ferrailleur": {
    "requiresAuth": true
  },
  "Calorifugeur": {
    "requiresAuth": true
  }
};
